import React from 'react';

import classNames from 'classnames';

import { Translate } from '../../../types/Localiser';

import styles from './deal-countdown.css';
import useDealCountdownTimeString from './useDealCountdownTimeString';

export type DealCountdownProps = {
  dealStartTime?: number;
  dealEndTime?: number;
  translate: Translate;
  language?: string;
  area?: string;
  className?: string;
};

export const DealCountdown: React.FC<DealCountdownProps> = ({
  dealStartTime,
  dealEndTime,
  translate,
  language,
  area,
  className,
}) => {
  const { timeString, label, status } = useDealCountdownTimeString(
    translate,
    dealStartTime,
    dealEndTime,
    language,
    area,
  );

  return (
    <div className={classNames(className ? styles[className] : styles.container, styles[status])}>
      {label && <span className={styles.label}>{label}</span>}
      {timeString && <span className={styles.timeString}>{timeString}</span>}
    </div>
  );
};
